import { type ReactNode } from "react";

import { useIsMobile } from "@/hooks/use-mobile";

// On desktop these pages render inside the shell's own <main> (Layout.tsx),
// so the wrapper must not be a second main landmark with the same id.
export const MobileContent = ({ children }: { children: ReactNode }) => {
  const isMobile = useIsMobile();
  const className = "mx-auto w-full max-w-screen-xl px-4";
  return isMobile ? (
    <main className={className} id="main-content" data-mobile-content>
      {children}
    </main>
  ) : (
    <div className={className} data-mobile-content>
      {children}
    </div>
  );
};
